import { Flex } from "@gravity-ui/uikit";
import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";

import { PriceProps } from "../../../../PriceProps";
import { ProductContentDescription } from "../ProductContentDescription";
import { ProductPriceSection } from "../ProductPriceSection";
import { ProductPriceSource } from "../ProductPriceSource";

export interface ProductDesktopLayoutProps {
  product: ProductDetailResponseDto;
  source: ProductDetailResponseDto["productSources"];
  platform: null | ProductSourceDtoSourceEnum;
  setPlatform: (platform: null | ProductSourceDtoSourceEnum) => void;
  reload: () => void;
  hasSubscribe?: boolean;
  isDesktop: boolean;
  priceProps: PriceProps;
}

export const ProductDesktopLayout = ({
  product,
  source,
  platform,
  setPlatform,
  hasSubscribe,
  reload,
  isDesktop,
  priceProps,
}: ProductDesktopLayoutProps) => {
  return (
    <Flex direction="column" gap="4">
      <ProductContentDescription product={product} />

      {hasSubscribe && (
        <ProductPriceSource
          source={source}
          platform={platform}
          setPlatform={setPlatform}
          reload={reload}
          isDesktop={isDesktop}
        />
      )}

      <ProductPriceSection {...priceProps} isDesktop={isDesktop} />
    </Flex>
  );
};
